var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c29da62e161715452d47cf35037ad42320b9fb82"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seedlang@seedlang"]={id:"c29da62e161715452d47cf35037ad42320b9fb82"};
      